export default __webpack_public_path__ + "static/media/0xbbe47167666100ec33de9079c1ee7b150ccbd874.7bd1c8d6.svg";